import React from 'react';
import { connect } from 'dva';
import BaseComponent from '../../../components/BaseComponent';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import PaymentForm from './PaymentForm';
import {StripeProvider, Elements } from 'react-stripe-elements';
import "../style/payment.scss"

class PaymentPage extends BaseComponent {
  componentWillMount() {
    const {dispatch, payment} = this.props;
    if(!payment.stripeApi){
      this.showError("API key is not set");
    }
  }

  render() {
    const {payment} = this.props;

    return (
      <section id="payment-page" className="page my-2">
        <DimioNotice {...payment} />

        <div className="container page box-gray">
          <StripeProvider apiKey={payment.stripeApi}>
            <Elements locale="ja">
              <PaymentForm {...this.props} />
            </Elements>
          </StripeProvider>
        </div>
      </section>
    );
  }
}

export default connect(({ payment }) => ({
  payment,
}))(PaymentPage);



// WEBPACK FOOTER //
// ./src/pages/payment/components/PaymentPage.js